import { ENV_TDM_APPID } from ".";
import { getDeviceId, getDeviceType } from "@/utils";
import { getUserInfo } from "@/utils/qwLogin";

export const tdmInit = () => {
  const _properties = {
    userId: getUserInfo()?.openid || "",
  };
  TDM.init({
    appId: Number(ENV_TDM_APPID),
    routeBaseUrl: "https://hc.tdm.qq.com:8013",
    ..._properties,
  })
    .then(() => {
      console.log("初始化成功");
    })
    .catch((errMessage) => {
      // 初始化失败
      console.error(errMessage);
    });
};

export const reportEvents = async (eventName, eventInfo) => {
  const _properties = {
    s_account: getUserInfo()?.openid || "", // 用户openid
    s_device_id: getDeviceId() || "", // 设备id 1安卓,2苹果,3网页
    s_device_type: getDeviceType() || "", // 设备类型
    s_channel: getUserInfo()?.channel || "", // 渠道1微信,2QQ
  };

  TDM.reportEvents({
    events: [
      {
        srcId: Number(ENV_TDM_APPID),
        eventName: eventName,
        eventInfo: { ..._properties, ...eventInfo },
      },
    ],
    success(result) {
      // console.log(result);
    },
    error(errMessage) {
      console.error(errMessage);
    },
  });
};
